(function ($) {
    $(document).ready(function () {
        $("form .open-contact-us").on("click", function () {
            var selectedVal = $('#ddlformName').val();
            if (selectedVal == '' || selectedVal == '0') {
                alert('please select from from the list');
                return false;
            }
            var url = $('form').attr('action') + "?formid=" + selectedVal;
            window.location.href = sanitizeHtmlStrings(url);

        });
    });

}(window.jQuery));